import React, { useState } from "react";
import { useVisibility } from "@/contexts/VisibilityContext";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Globe, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

export function PublicModeToggle() {
  const { isPublicMode, activatePublicMode, deactivatePublicMode } = useVisibility();
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    setLoading(true);
    try {
      if (isPublicMode) {
        await deactivatePublicMode();
      } else {
        await activatePublicMode();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className={cn(
        "p-4 border-2",
        isPublicMode ? "border-yellow-500 bg-yellow-500/10" : "border-border"
      )}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          {isPublicMode ? (
            <Globe className="h-5 w-5 text-yellow-500" />
          ) : (
            <Lock className="h-5 w-5 text-muted-foreground" />
          )}
          <div>
            <div className="font-semibold">Public Mode</div>
            <div className="text-xs text-muted-foreground">
              {isPublicMode
                ? "All content is currently visible to everyone"
                : "Normal visibility rules are active"}
            </div>
          </div>
        </div>
        <Switch checked={isPublicMode} onCheckedChange={handleToggle} disabled={loading} />
      </div>
      {isPublicMode && (
        <div className="mt-3 pt-3 border-t border-yellow-500/30">
          <p className="text-xs text-yellow-600 dark:text-yellow-400">
            Original settings are saved and will be restored when you deactivate Public Mode.
          </p>
        </div>
      )}
    </Card>
  );
}
